import { ReactElement } from 'react';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import '../index.less';

if (SpringConfigs.IS_RTL) {
  import('../rtl.less');
}

type TProps = {
  className?: string;
};

const TEAM_SCORE_SKELETON_COUNT = 5;

export const MOBAGamesStatisticsScoresSkeleton = ({
  className = ''
}: TProps): ReactElement => {
  return (
    <div
      className={cc([
        'mobaGames__statistics',
        {
          'mobaGames__statistics--mobile': isMobile(),
          [className]: className
        }
      ])}
    >
      <div
        className={cc([
          'mobaGames__statistics--scores',
          { 'mobaGames__statistics--scoresMobile': isMobile() }
        ])}
      >
        <div
          className={cc([
            'mobaGames__statistics--scoresContainer',
            {
              'mobaGames__statistics--scoresContainerLast':
                SpringConfigs.IS_RTL && !isMobile()
            }
          ])}
        >
          {isMobile() && SpringConfigs.TEAM_LOGOS && (
            <span className="mobaGames__statistics-column team-logo">
              <Skeleton.Avatar
                style={{ width: 26, height: 26 }}
                className="mobaGames__statistics-column team-logo"
              />
              <span style={{ margin: 8 }}>-</span>
            </span>
          )}
          <div className="mobaGames__statistics--teamScore">
            {createArray(TEAM_SCORE_SKELETON_COUNT).map(key => (
              <div
                key={key}
                className="mobaGames__statistics--teamScoreContainer"
              >
                <Skeleton.Avatar
                  style={{ width: 26, height: 26 }}
                  className="mobaGames__statistics--scoreIcon team"
                />
                <span>
                  <Skeleton.Button
                    style={{ width: 12, minWidth: 12, height: 20 }}
                  />
                </span>
              </div>
            ))}
          </div>
        </div>
        {!isMobile() && (
          <div className="mobaGames__statistics--vs">
            <span>VS</span>
            <span>
              <Skeleton.Button
                style={{ width: 30, minWidth: 30, height: 15 }}
              />
            </span>
          </div>
        )}
        <div
          className={cc([
            'mobaGames__statistics--scoresContainer',
            {
              'mobaGames__statistics--scoresContainerLast':
                !SpringConfigs.IS_RTL && !isMobile()
            }
          ])}
        >
          {isMobile() && SpringConfigs.TEAM_LOGOS && (
            <span className="mobaGames__statistics-column team-logo">
              <Skeleton.Avatar
                style={{ width: 26, height: 26 }}
                className="mobaGames__statistics-column team-logo"
              />
              <span style={{ margin: 8 }}>-</span>
            </span>
          )}
          <div className="mobaGames__statistics--teamScore">
            {createArray(TEAM_SCORE_SKELETON_COUNT).map(key => (
              <div
                key={key}
                className="mobaGames__statistics--teamScoreContainer"
              >
                <Skeleton.Avatar
                  style={{ width: 26, height: 26 }}
                  className="mobaGames__statistics--scoreIcon team"
                />
                <span>
                  <Skeleton.Button
                    style={{ width: 12, minWidth: 12, height: 20 }}
                  />
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
